import React from 'react';
import { RouteComponentProps } from 'react-router';
import VipCodeContainer from '../../containers/VipCodeContainer/VipCodeContainer';

const VipCodePage: React.FC<RouteComponentProps> = props => {
  return <VipCodeContainer {...props} />;
};

export default VipCodePage;
